import type { CambioTipo } from '@zonasocioscofarte/types'
import {
  downloadTicketAttachment,
  formatFechaHora,
  formatFileSize,
  getTicketAuthHeaders
} from '@utils/ticketLabels'

export const CAMBIO_TIPO_LABELS: Record<CambioTipo, string> = {
  nueva_funcionalidad: 'Nueva funcionalidad',
  correccion: 'Corrección',
  mejora: 'Mejora'
}

export const CAMBIO_TIPO_COLORS: Record<CambioTipo, string> = {
  nueva_funcionalidad: 'border-purple-200 bg-purple-50 text-purple-700',
  correccion: 'border-amber-200 bg-amber-50 text-amber-700',
  mejora: 'border-emerald-200 bg-emerald-50 text-emerald-700'
}

export const CAMBIOS_REFRESH_EVENT = 'ecofarte:cambios-refresh'

export { formatFechaHora, formatFileSize }

export function getCambioAuthHeaders(): Record<string, string> {
  return getTicketAuthHeaders()
}

export function downloadCambioAttachment(
  path: string,
  fileName: string,
  headers: Record<string, string>
): Promise<void> {
  return downloadTicketAttachment(path, fileName, headers)
}

export function notifyCambiosChanged(): void {
  window.dispatchEvent(new Event(CAMBIOS_REFRESH_EVENT))
}
